export const quoteStatus = {
  SUBMITTED: 'Submitted',
  CREATED: 'Created',
  APPROVED: 'Approved',
  DRAFT: 'Draft',
};
